'use client';

import { useEffect, useState } from 'react';
import { GoogleAnalytics } from '@next/third-parties/google';
import { onConsentGranted, readConsent } from '@/lib/analytics/consent';

/**
 * Mounts GA4 only once the visitor has accepted cookies.
 *
 * Rendering <GoogleAnalytics> unconditionally would load googletagmanager and set
 * _ga cookies before consent, which is a POPIA exposure. Rendering it after
 * consent keeps the tag itself out of the document for anyone who declined.
 *
 * The measurement ID comes from NEXT_PUBLIC_GA_MEASUREMENT_ID and falls back to
 * the same value already used for Firebase Analytics in src/firebase/config.ts.
 * Leave the env var unset in production only if you have deliberately turned
 * GA4 off — analytics will then silently no-op rather than throw.
 */
const GA_ID =
  process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || 'G-Z248M7MT9H';

export function AnalyticsProvider() {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (readConsent() === 'granted') {
      setAllowed(true);
      return;
    }
    return onConsentGranted(() => setAllowed(true));
  }, []);

  if (!allowed || !GA_ID) return null;

  return <GoogleAnalytics gaId={GA_ID} />;
}
